export default __webpack_public_path__ + "static/media/arrow-right.1e1337ca.svg";